import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Space, Tag } from 'antd';

const SEVERITY_TYPE = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

/**
 * Everything the translation could not settle on its own, shown before a file is
 * produced rather than after the group queries it.
 *
 * @param {Object} props - Component props
 * @param {Array} props.findings - Findings from a preview or a generated run
 * @returns {JSX.Element} The findings list
 */
export default function FindingsList({ findings = [] }) {
  const { t } = useTranslation(['tables']);
  const gr = (key) => t(`groupReporting.${key}`, { ns: 'tables' });

  if (!findings.length) {
    return <Alert type="success" showIcon message={gr('noFindings')} />;
  }

  const order = { ERROR: 0, WARNING: 1, INFO: 2 };
  const sorted = [...findings].sort(
    (a, b) => (order[a.severity] ?? 3) - (order[b.severity] ?? 3)
  );

  return (
    <Space direction="vertical" style={{ width: '100%' }} size={8}>
      {sorted.map((finding, index) => (
        <Alert
          key={`${finding.code}-${index}`}
          type={SEVERITY_TYPE[finding.severity] || 'info'}
          showIcon
          message={finding.message}
          description={
            finding.amount == null && finding.rowCount == null ? null : (
              <Space size={8} wrap>
                {finding.amount != null && (
                  <Tag>
                    {Number(finding.amount).toLocaleString('sr-RS', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Tag>
                )}
                {finding.rowCount != null && (
                  <Tag>
                    {finding.rowCount} {gr('rows').toLowerCase()}
                  </Tag>
                )}
              </Space>
            )
          }
        />
      ))}
    </Space>
  );
}
